<ui-dialog
    [open]="currentlyOpenDialog === 'T4_ISSUE_CONFIRMATION'"
    formDialog
    header="payroll.taxForms.finalizeT4s"
    (primaryButtonPressed)="finalize(t4IssueForm)"
    (closing)="closeDialog()"
    [form]="t4IssueForm.form"
>
    <app-t4-issue-form #t4IssueForm></app-t4-issue-form>
</ui-dialog>

<ui-dialog
    [open]="currentlyOpenDialog === 'SELECT_AMENDED_T4'"
    formDialog
    header="payroll.taxForms.addAmendedT4"
    (primaryButtonPressed)="addAmendedTax(addAmendedTaxForm)"
    (closing)="closeDialog(); addAmendedTaxForm?.clear()"
    size="small"
    [form]="addAmendedTaxForm?.form"
>
    @if (currentlyOpenDialog === 'SELECT_AMENDED_T4') {
        <app-add-amended-tax-form
            [employeesInAmendment]="employeesInAmendment()"
            #addAmendedTaxForm
        ></app-add-amended-tax-form>
    }
</ui-dialog>

<ui-dialog
    [open]="currentlyOpenDialog === 'BULK_EMAIL_CONFIRMATION'"
    header="payroll.taxForms.emailAllT4s"
    confirmationDialog
    (closing)="closeDialog()"
    (primaryButtonPressed)="bulkEmail(); closeDialog()"
>
    <p>{{ 'payroll.taxForms.areYouSureYouWishToEmailEachEmployeeTheirRespectiveT4' | translate }}</p>
</ui-dialog>

<ui-dialog
    [open]="currentlyOpenDialog === 'T4_DELETE_CONFIRMATION'"
    header="payroll.taxForms.T4.deleteAll"
    confirmationDialog
    (closing)="closeDialog()"
    (primaryButtonPressed)="delete(); closeDialog()"
>
    <p>{{ 'payroll.taxForms.T4.areYouSure' | translate }}</p>
</ui-dialog>

<div class="ui basic segment" [class.loading]="isLoading">
    <app-header
        title="{{ t4Summary.name }}"
        [back]="true"
        [backRoute]="backRoute"
        [menuService]="payrollModuleMenuService"
        [badgeOptions]="headerBadgeOptions"
        [contextMenu]="true"
    >
        <div class="buttons">
            <ui-button *ngIf="t4Summary.isIssued()" (click)="amend()" type="outline">{{
                'payroll.taxForms.createAmendment' | translate
            }}</ui-button>
            <ui-button *ngIf="t4Summary.isIssued()" (click)="download()" type="primary">{{
                'payroll.taxForms.downloadTaxPackage' | translate
            }}</ui-button>
            <ui-button
                *ngIf="t4Summary.isOpen"
                (click)="currentlyOpenDialog = 'T4_ISSUE_CONFIRMATION'"
                type="primary"
                >{{ 'payroll.taxForms.finalizeT4s' | translate }}</ui-button
            >
        </div>

        <app-context-item
            *ngIf="t4Summary.isOpen && t4Summary.isOriginal()"
            label="delete"
            (click)="currentlyOpenDialog = 'T4_DELETE_CONFIRMATION'"
        ></app-context-item>

        <app-context-item
            *ngIf="t4Summary.isIssued()"
            label="payroll.taxForms.downloadT619"
            (click)="downloadT619()"
        ></app-context-item>
    </app-header>

    <ui-banner variant="info" class="padding-bottom-2">
        <div [innerHTML]="'payroll.taxForms.youHaveToFileYourT4sWithTheCraUsingTheir' | translate"></div>
    </ui-banner>

    <ui-banner
        variant="danger"
        *ngIf="definedContributionAndProfitSharingNotificationEmployeesCount > 0"
        class="padding-bottom-2"
    >
        <div>
            {{ 'payroll.taxForms.ourRecordsShowThatYouHadARPPWithADCAndOrPS' | translate: { year: t4Summary.year } }}
            <ng-container *ngTemplateOutlet="links"></ng-container>
        </div>

        <div class="margin-left-2">
            <b
                >{{ definedContributionAndProfitSharingNotificationEmployeesCount }}&nbsp;{{
                    'payroll.taxForms.employees' | translate
                }}</b
            >
        </div>
    </ui-banner>

    <ui-banner variant="danger" *ngIf="definedBenefitsNotificationEmployeesCount > 0" class="padding-bottom-2">
        <div>
            {{ 'payroll.taxForms.ourRecordsShowThatYouHadARPPWithADB' | translate: { year: t4Summary.year } }}
            <ng-container *ngTemplateOutlet="links"></ng-container>
        </div>

        <div class="margin-left-2">
            <b>{{ definedBenefitsNotificationEmployeesCount }}&nbsp;{{ 'payroll.taxForms.employees' | translate }}</b>
        </div>
    </ui-banner>

    <ng-template #links>
        <div [innerHTML]="'payroll.taxForms.forMoreInformationPleaseVisit' | translate"></div>
    </ng-template>

    <app-table
        [table]="employeeT4Table"
        [title]="'payroll.taxForms.employeeT4s' | translate"
        [useStickyHeader]="false"
        [showOffset]="false"
    >
        <div class="buttons">
            <ui-button
                *ngIf="t4Summary.isIssued()"
                (click)="currentlyOpenDialog = 'BULK_EMAIL_CONFIRMATION'"
                type="outline"
                >{{ 'payroll.taxForms.emailAllT4s' | translate }}</ui-button
            >
            <ui-button
                *ngIf="t4Summary.isOpen && t4Summary.isAmendment"
                (click)="currentlyOpenDialog = 'SELECT_AMENDED_T4'"
                type="outline"
                >{{ 'payroll.taxForms.addAmendedT4' | translate }}</ui-button
            >
        </div>
    </app-table>

    <ui-card>
        <app-segment-header title="payroll.taxForms.t4SummaryDetails"></app-segment-header>

        <div class="record-row app-grid padding-bottom-2">
            <label class="columns-6 small-columns-12">{{ 'payroll.taxForms.lineEmploymentIncome' | translate }} </label>
            <span class="columns-6 small-columns-12 text-align-right">{{
                t4Summary.totEmptIncamt || ('na' | translate)
            }}</span>
        </div>

        <hr class="margin-y-0" />

        <div class="record-row app-grid padding-y-2">
            <label class="columns-6 small-columns-12"
                >{{ 'payroll.taxForms.lineEmployeesCppContributions' | translate }}
            </label>
            <span class="columns-6 small-columns-12 text-align-right">{{
                t4Summary.totEmpeCppAmt || ('na' | translate)
            }}</span>
        </div>

        <hr class="margin-y-0" />

        <div class="record-row app-grid padding-y-2">
            <label class="columns-6 small-columns-12"
                >{{ 'payroll.taxForms.lineEmployeesEiPremiums' | translate }}
            </label>
            <span class="columns-6 small-columns-12 text-align-right">{{
                t4Summary.totEmpeEipAmt || ('na' | translate)
            }}</span>
        </div>

        <hr class="margin-y-0" />

        <div class="record-row app-grid padding-y-2">
            <label class="columns-6 small-columns-12"
                >{{ 'payroll.taxForms.lineEmployersEiPremiums' | translate }}
            </label>
            <span class="columns-6 small-columns-12 text-align-right">{{
                t4Summary.totEmprEipAmt || ('na' | translate)
            }}</span>
        </div>

        <hr class="margin-y-0" />

        <div class="record-row app-grid padding-y-2">
            <label class="columns-6 small-columns-12"
                >{{ 'payroll.taxForms.lineRegisteredPensionPlanRppContributions' | translate }}
            </label>
            <span class="columns-6 small-columns-12 text-align-right">{{
                t4Summary.totRppCntrbAmt || ('na' | translate)
            }}</span>
        </div>

        <hr class="margin-y-0" />

        <div class="record-row app-grid padding-y-2">
            <label class="columns-6 small-columns-12"
                >{{ 'payroll.taxForms.lineIncomeTaxDeducted' | translate }}
            </label>
            <span class="columns-6 small-columns-12 text-align-right">{{
                t4Summary.totItxDdctAmt || ('na' | translate)
            }}</span>
        </div>

        <hr class="margin-y-0" />

        <div class="record-row app-grid padding-y-2">
            <label class="columns-6 small-columns-12"
                >{{ 'payroll.taxForms.lineEmployersCppContributions' | translate }}
            </label>
            <span class="columns-6 small-columns-12 text-align-right">{{
                t4Summary.totEmprCppAmt || ('na' | translate)
            }}</span>
        </div>

        <hr class="margin-y-0" />

        <div class="record-row app-grid padding-top-2">
            <label class="columns-6 small-columns-12"
                >{{ 'payroll.taxForms.linePensionAdjustment' | translate }}
            </label>
            <span class="columns-6 small-columns-12 text-align-right">{{
                t4Summary.totPadjAmt || ('na' | translate)
            }}</span>
        </div>
    </ui-card>
</div>
